/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';
import { getUpMedia } from '../../styles';
import { TableCell } from './TableCell';

export const OrderCell = styled(TableCell)`
  width: 26px;
  min-width: 26px;
  padding: 12px 6px 12px 0;
  ${getUpMedia('sm')} {
    width: 38px;
    min-width: 38px;
    padding-left: 12px;
  }
`;
